(() => {
  const main = document.getElementById('MainContent');
  if (!main) return;
  const restore = (image, priority = 'auto') => {
    if (!image?.dataset.curioSrcset) return;
    image.fetchPriority = priority;
    image.loading = 'eager';
    image.srcset = image.dataset.curioSrcset;
    if (image.dataset.curioSrc) image.src = image.dataset.curioSrc;
    image.removeAttribute('data-curio-srcset');
    image.removeAttribute('data-curio-src');
  };
  // Native loading=lazy may fetch images far outside the viewport. Keep lower
  // homepage image URLs out of src/srcset until the actual image approaches it.
  const viewportSelector = 'img[data-curio-viewport-src]';
  const restoreViewport = image => {
    if (!image?.dataset.curioViewportSrc) return;
    image.loading = 'eager';
    image.fetchPriority = 'low';
    if (image.dataset.curioViewportSrcset) image.srcset = image.dataset.curioViewportSrcset;
    image.src = image.dataset.curioViewportSrc;
    image.removeAttribute('data-curio-viewport-src');
    image.removeAttribute('data-curio-viewport-srcset');
  };
  const watched = new WeakSet();
  const viewportObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      restoreViewport(entry.target);
      viewportObserver.unobserve(entry.target);
    });
  }, {rootMargin: '150px 0px'}) : null;
  const watchViewport = scope => {
    scope.querySelectorAll(viewportSelector).forEach(image => {
      if (!viewportObserver) return restoreViewport(image);
      if (watched.has(image)) return;
      watched.add(image);
      viewportObserver.observe(image);
    });
  };
  watchViewport(main);
  document.addEventListener('shopify:section:load', event => watchViewport(event.target));
  main.addEventListener('focusin', event => {
    event.target.closest?.('.product-card-wrapper, .ed-card')?.querySelectorAll(viewportSelector).forEach(restoreViewport);
  });
  const secondary = event => {
    if (event.type === 'pointerover' && !matchMedia('(hover: hover)').matches) return;
    restore(event.target.closest?.('.product-card-wrapper')?.querySelector('.curio-deferred-secondary[data-curio-srcset]'));
  };
  main.addEventListener('pointerover', secondary, {passive: true});
  main.addEventListener('focusin', secondary);
  main.addEventListener('sliderChanged', event => {
    event.detail?.currentElement?.querySelectorAll('img[data-curio-srcset]').forEach(image => restore(image));
    event.detail?.currentElement?.querySelectorAll(viewportSelector).forEach(restoreViewport);
  });
  main.addEventListener('curio:media-selected', event => {
    event.target.querySelectorAll(`[data-media-id="${event.detail.mediaId}"] img[data-curio-srcset]`).forEach(image => restore(image));
  });
})();
